import React, { useRef, useState } from 'react';
import Button from '../../../shared/components/Button/Button';
import { API_BASE_URL } from '../../../utils/apiClient';
import { uploadRHUserProfilePhoto } from '../rh.api';
import { getRHInitials, getRHUserName } from '../utils/rhFormatters';

export const rhPhotoUrl = source => !source || /^(?:blob:|data:|https?:)/i.test(source) ? source : `${API_BASE_URL}${source}`;

export default function RHProfilePhoto({ user, photo, canEdit = false, onSaved, showAvatar = true }) {
  const fileInputRef = useRef(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');
  const selectPhoto = async ({ target }) => {
    const file = target.files?.[0];
    target.value = '';
    if (!file) return;
    setError(''); setNotice('');
    if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) return setError('Sélectionnez une photo JPEG, PNG ou WebP.');
    if (!file.size || file.size > 5 * 1024 * 1024) return setError('La photo doit être non vide et ne pas dépasser 5 Mo.');
    setSaving(true);
    try {
      await uploadRHUserProfilePhoto(user.id, file);
      setNotice('Photo enregistrée.');
      try { await onSaved?.(); } catch { setNotice('Photo enregistrée. Actualisez la page pour l’afficher.'); }
    } catch (failure) { setError(failure.message || 'Le chargement de la photo a échoué.'); }
    finally { setSaving(false); }
  };
  return <div className="rh-profile-photo">
    {showAvatar && (photo ? <img className="rh-summary-band__avatar" src={rhPhotoUrl(photo)} alt={`Portrait de ${getRHUserName(user)}`} /> : <div className="rh-summary-band__avatar rh-summary-band__initials">{getRHInitials(user)}</div>)}
    {canEdit && <>
      <input ref={fileInputRef} hidden type="file" aria-label={photo ? 'Changer la photo de profil' : 'Ajouter une photo de profil'} accept="image/jpeg,image/png,image/webp" disabled={saving} onChange={selectPhoto} />
      <Button variant="secondary" size="small" loading={saving} onClick={() => fileInputRef.current?.click()} sx={{ alignSelf: 'flex-start', maxWidth: '100%', whiteSpace: 'normal' }}>{photo ? 'Changer la photo de profil' : 'Ajouter une photo de profil'}</Button>
      <small>JPEG, PNG ou WebP · 5 Mo maximum</small>
    </>}
    {saving && <p role="status">Enregistrement de la photo…</p>}{notice && <p role="status">{notice}</p>}{error && <p role="alert">{error}</p>}
  </div>;
}
